export default [
    {
        title: 'مالی و کیف‌پول',
        icon: 'bx bx-wallet',
        children: [
            {
                title: 'کیف‌پول کاربران',
                route: { name: 'wallet' },
                resource: 'WithdrawalManager',
                action: 'show',
            },
            {
                title: 'درخواست‌های برداشت',
                route: { name: 'withdrawal' },
                resource: 'WithdrawalManager',
                action: 'show',
            },
            {
                title: 'پرداخت‌های درگاه',
                route: { name: 'payment' },
                resource: 'PaymentManager',
                action: 'show',
            },
            {
                title: 'بانک‌ها',
                route: { name: 'bank' },
                resource: 'BankManager',
                action: 'show',
            },
        ],
    },
]
